import React, { useEffect, useState } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';

const PocForm = ({
  handleValue,
  pocById,
  getPocData,
  id,
  leadId,
  noTitle,
  className = 'row mx-0',
}) => {
  const pocInputs = {
    name: '',
    designation: '',
    contact_no: '',
    email: '',
  };
  const editInputs = {
    name: '',
    designation: '',
    contact_no: '',
    email: '',
  };
  const [editVal, setEditVal] = useState(editInputs);
  const [pocData, setPocData] = useState(pocInputs);

  const handlePocData = () => {
    if (
      pocData.name !== '' &&
      pocData.designation !== '' &&
      pocData.contact_no !== '' &&
      pocData.email !== ''
    ) {
      if (id) {
        handleValue({
          id: pocById.id,
          lead_id: leadId,
          name: editVal.name,
          designation: editVal.designation,
          contact_no: editVal.contact_no,
          email: editVal.email,
        });
      } else {
        handleValue({
          ...pocData,
          designation: pocData.designation,
          contact_no: pocData.contact_no,
          email: pocData.email,
          lead_id: leadId,
        });
      }
    } else {
      handleValue(null);
    }
  };

  useEffect(() => {
    handlePocData();
  }, [pocData]);

  useEffect(() => {
    if (pocById) {
      setEditVal(pocById);
    }
  }, [pocById]);

  useEffect(() => {
    setEditVal(editInputs);
  }, []);

  useEffect(() => {
    if (id) {
      handleValue({
        id: pocById.id,
        lead_id: leadId,
        name: editVal.name,
        designation: editVal.designation,
        contact_no: editVal.contact_no,
        email: editVal.email,
      });
    }
  }, [editVal]);

  return (
    <FormSection
      title={
        id
          ? localization.editPocDetail
          : noTitle
          ? ''
          : localization.pocDetailTitle
      }
    >
      <div className={`${className}`}>
        <ConstantInput
          value={editVal.name}
          label={localization.POCName}
          regex={Regex.text.test(pocData.name)}
          errorMsg={localization.requiredPocName}
          type="text"
          required
          isStarRequired={true}
          handleChange={(value) => {
            setPocData({ ...pocData, name: value });
            setEditVal({ ...editVal, name: value });
          }}
        />
        <ConstantInput
          value={editVal.designation}
          label={localization.POCDesignation}
          regex={Regex.text.test(pocData.designation)}
          errorMsg={localization.requiredPocDesig}
          type="text"
          required
          isStarRequired={true}
          handleChange={(value) => {
            setPocData({ ...pocData, designation: value });
            setEditVal({ ...editVal, designation: value });
          }}
        />
        <ConstantInput
          value={pocById.id ? `${editVal.contact_no}` : pocData.contact_no}
          label={localization.phoneNumber}
          regex={Regex.phoneNumber.test(pocData.contact_no)}
          errorMsg={localization.phoneError}
          maxLength={10}
          minLength={10}
          type="text"
          required
          isStarRequired={true}
          handleChange={(value) => {
            setPocData({ ...pocData, contact_no: value });
            setEditVal({ ...editVal, contact_no: value });
          }}
        />
        <ConstantInput
          value={editVal.email}
          label={localization.emailAddress}
          regex={Regex.email.test(pocData.email)}
          errorMsg={localization.emailError}
          type="email"
          required
          isStarRequired={true}
          handleChange={(value) => {
            setPocData({ ...pocData, email: value });
            setEditVal({ ...editVal, email: value });
          }}
        />
      </div>
    </FormSection>
  );
};

export default PocForm;
